export default function fetchTimeout(url, options, timeout) {
	const controller = new AbortController();
	const { signal } = controller;
	return new Promise((resolve, reject) => {
		const timer = setTimeout(() => {
			controller.abort();
			reject(new Error('TIMEOUT'));
		}, timeout);
		fetch(url, { ...options, signal })
			.then(value => {
				clearTimeout(timer);
				resolve(value);
			})
			.catch(reason => {
				clearTimeout(timer);
				reject(reason);
			});
	});
}
